<template>
  <div class="btn-group champs-optionnels" :class="{open: ouvert}" v-if="disponibles.length">
    <button type="button" class="btn btn-default btn-sm" @click.stop="basculer()">
      <i class="fa fa-plus"></i> Ajouter
      <span class="caret"></span>
    </button>
    <ul class="dropdown-menu">
      <li v-for="champ in disponibles" :key="champ.cle">
        <a href="#" @click.prevent="activer(champ.cle)">
          <i class="fa fa-fw" :class="champ.icone"></i> {{ champ.libelle }}
        </a>
      </li>
    </ul>
  </div>
</template>

<script type="text/babel">
  // Ordre d'apparition dans le menu : du plus courant au plus rare
  const CHAMPS = [
    {cle: 'tva', libelle: 'TVA', icone: 'fa-calculator'},
    {cle: 'remise', libelle: 'Remise', icone: 'fa-tags'},
    {cle: 'frais', libelle: 'Frais', icone: 'fa-truck'},
    {cle: 'notes', libelle: 'Note', icone: 'fa-sticky-note-o'},
    {cle: 'conditions', libelle: 'Conditions de paiement', icone: 'fa-gavel'},
    {cle: 'echeance', libelle: 'Date d\'échéance', icone: 'fa-calendar'},
    {cle: 'reference', libelle: 'Référence / bon de commande', icone: 'fa-file-text-o'},
    {cle: 'paiement', libelle: 'Coordonnées de paiement', icone: 'fa-university'},
    {cle: 'qr', libelle: 'QR de paiement SEPA', icone: 'fa-qrcode'},
    {cle: 'logo', libelle: 'Logo', icone: 'fa-image'}
  ]

  export default {
    name: 'ChampsOptionnels',
    props: {
      options: {type: Object, required: true},
      // Champs à masquer quand leur prérequis manque (ex. librairie QR absente)
      indisponibles: {type: Array, default: function () { return [] }}
    },
    data () {
      return {
        ouvert: false
      }
    },
    computed: {
      disponibles () {
        const composant = this
        return CHAMPS.filter(function (champ) {
          return !composant.options[champ.cle] &&
            composant.indisponibles.indexOf(champ.cle) === -1
        })
      }
    },
    mounted () {
      document.addEventListener('click', this.fermerSiDehors)
      document.addEventListener('keydown', this.fermerSiEchap)
    },
    beforeDestroy () {
      document.removeEventListener('click', this.fermerSiDehors)
      document.removeEventListener('keydown', this.fermerSiEchap)
    },
    methods: {
      basculer () {
        this.ouvert = !this.ouvert
      },
      activer (cle) {
        this.ouvert = false
        this.$emit('activer', cle)
      },
      fermerSiDehors (evenement) {
        if (this.ouvert && !this.$el.contains(evenement.target)) {
          this.ouvert = false
        }
      },
      fermerSiEchap (evenement) {
        if (this.ouvert && evenement.key === 'Escape') {
          this.ouvert = false
        }
      }
    }
  }
</script>

<style scoped>
  .champs-optionnels .dropdown-menu {
    /* Se limite à la fenêtre plutôt qu'à une hauteur fixe : la liste s'affiche
       en entier quand la place existe, et devient défilable sur petit écran */
    max-height: calc(100vh - 170px);
    overflow-y: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/Outils/Facture/ChampsOptionnels.vue